import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import VueCookies from 'vue-cookies'
import App from './App.vue';
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import NetworkService from './util/netservice';
// import moment from 'moment';
import moment from 'moment-timezone';

// moment.tz.setDefault('Asia/Jakarta')

Vue.prototype.moment = moment
//font awesome 
library.add(faUserSecret)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// loader
import loader from "vue-ui-preloader";
Vue.use(loader);

// router setup
import router from './routes/router';
import i18n from './i18n';
// import './registerServiceWorker'

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueCookies)

// set default config

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.prototype.$http = NetworkService;
Vue.prototype.$cookie = VueCookies;
Vue.$cookies.config('1d')



delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconSize: [30, 30], // size of the icon
  iconUrl: require("@/assets/img/marker default.png"),
  // shadowUrl: require("@/assets/img/marker default.png"),
  // iconUrl: require("@/assets/img/icon_on.png"),
  // iconSize: [30, 35], // size of the icon
  // shadowUrl: require("@/assets/img/marker-shadow.png"),
  iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
  // shadowAnchor: [30, 30], // the same for the shadow
  // shadowSize: [30, 30],
  popupAnchor: [-3, -76],
  // iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  // iconSize: [30, 35], 
  // iconAnchor: [28, 30], // point of the icon which will correspond to marker's location
  // shadowAnchor: [30, 30], // the same for the shadow
  shadowSize: [30, 30],
  // popupAnchor: [-3, -76]
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n,
});
